export const archivedProjects = [
  {
    id: 1,
    title: "Reduce Power Consumption",
    department: "Production",
    lead: "Alice",
    completedOn: "2024-11-15",
    impact: "High",
  },
  {
    id: 2,
    title: "Improve Supplier On-Time Delivery",
    department: "Logistics",
    lead: "Bob",
    completedOn: "2024-10-01",
    impact: "Medium",
  },
  {
    id: 3,
    title: "Standardize QA Checklists",
    department: "Quality",
    lead: "Charlie",
    completedOn: "2024-12-21",
    impact: "Low",
  },
  {
    id: 4,
    title: "Optimize Warehouse Layout",
    department: "Logistics",
    lead: "Dana",
    completedOn: "2025-01-10",
    impact: "High",
  },
  {
    id: 5,
    title: "Line Balancing Improvement",
    department: "Production",
    lead: "Eve",
    completedOn: "2025-02-03",
    impact: "High",
  },
];
